import useU2000AxiosNonAuthenticated from "../../axios/U2000UseAxiosNonAuthenticated";
import { useU2000AuthContext } from "../../context/auth/U2000UseAuthContext";

const LOGICALUNIT_URL = "U2001";
const LOGOUT_URL = LOGICALUNIT_URL + "/logout";

type LogoutFn = () => Promise<void>;

const useU2000Logout = (): LogoutFn => {
  const { logout } = useU2000AuthContext();
  const u2000AxiosNonAuthenticated = useU2000AxiosNonAuthenticated();

  const doLogout: LogoutFn = async () => {
    let logoutError: unknown = null;
    try {
      await u2000AxiosNonAuthenticated.get(LOGOUT_URL);
    } catch (error) {
      console.error(error);
      logoutError = error;
    } finally {
      // Toujours nettoyer l'état local (évite une session zombie si le cookie serveur est déjà invalidé).
      logout();
    }
    if (logoutError) {
      throw logoutError;
    }
  };

  return doLogout;
};

export default useU2000Logout;
